// extracted by mini-css-extract-plugin
export var close = "styles-module--close--hBRw7";
export var component = "styles-module--component--6ETTq";
export var inner = "styles-module--inner--XU2U7";
export var open = "styles-module--open--LfuCe";
export var video = "styles-module--video--LpwxW";
export var wrap = "styles-module--wrap--5PBh-";